module.exports = __webpack_public_path__ + "static/img/news5.fca66b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/news5.jpg
// module id = ptGn
// module chunks = 1